module.exports = __webpack_public_path__ + "static/bg-developing-13e6d17700134f9a8d39a53192c58729.svg";